import { Table } from "antd"
import { programDisplayIdxColumns, useGetProgramListForDisplayIdx } from "./model"

interface IProgramDisplayIdx {
    id: number;
    isDisplay: boolean;
    displayIdx: number;
    title: string;
    bookingPeriod: [string, string];
    programPeriod: [string, string];
}

const ProgramDisplayIdx = () => {
    const { data = [], isFetching } = useGetProgramListForDisplayIdx<IProgramDisplayIdx[]>()

    return <>
        <div style={{ fontWeight: 700, fontSize: '18px', marginBottom: '17px' }}>
            노출 순서 관리
        </div>
        <Table loading={isFetching} dataSource={data.filter(q => q.isDisplay).sort((a, b) => (b.displayIdx ?? 0) - (a.displayIdx ?? 0))} rowKey={'id'} columns={programDisplayIdxColumns} />
    </>
}

export default ProgramDisplayIdx